import { render, staticRenderFns } from "./DevicePendingList.vue?vue&type=template&id=c75a3e5c&scoped=true&"
import script from "./DevicePendingList.vue?vue&type=script&lang=js&"
export * from "./DevicePendingList.vue?vue&type=script&lang=js&"
import style0 from "./DevicePendingList.vue?vue&type=style&index=0&id=c75a3e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75a3e5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VChip,VDataTable,VIcon,VListItem,VMenu})
